import React from 'react'
import { cn } from '@/utilities/cn'

export interface SpacerProps {
  className?: string
  /** Spacing magnitude in rem units. */
  size: number
  /**
   * `vertical` (default) sets a height — pushes following blocks down.
   * `horizontal` sets a width — pushes flex/inline siblings to the side.
   */
  orientation?: 'vertical' | 'horizontal' | string
}

export const Spacer: React.FC<SpacerProps> = ({ className, size, orientation }) => {
  const isHorizontal = orientation === 'horizontal'
  return (
    <div
      className={cn(isHorizontal ? 'inline-block' : 'w-full', className)}
      style={isHorizontal ? { width: size + 'rem' } : { height: size + 'rem' }}
    />
  )
}
